import axios from 'axios';

const axios8001 = axios.create({
  baseURL: 'https://customersapi-22559651326.us-east1.run.app', 
});

// const axios8001 = axios.create({
//   baseURL: 'http://localhost:8001', // Set the base URL here
// });

export default axios8001;
